import { Typography } from '@mui/material'
import { useEffect } from 'react'
import { ChevronRight } from 'react-feather'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { actions } from '../../BasicQueriesState'
import { Container, Menu, MenuItem } from './BasicQueries.styles'
import { menus } from './menu'

export const BasicQueries = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.clearState())
  }, [dispatch])

  return (
    <Container >
      <Menu>
        <Typography variant='h6' fontWeight='bold'>Consultas</Typography>
        {
          menus.map((item, index) => (
            <MenuItem onClick={() => history.push(item.path)} key={index}>
              <div>{item.label}</div>
              <ChevronRight />
            </MenuItem>
          ))
        }
      </Menu>
    </Container>
  )
}
